var _rect, _rect2, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWpforms(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1080 1080"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: "100%",
    height: "100%",
    fill: "transparent"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    x: -50,
    y: -50,
    fill: "none",
    rx: 0,
    ry: 0,
    transform: "translate(87.91 219.41)",
    vectorEffect: "non-scaling-stroke"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#7eaaba",
    d: "M149.052 646.814c56.092 7.959 104.983-5.306 145.157-40.932l67.083 3.79-36.384 106.878c-40.553 64.43-98.92 77.695-159.18 73.905l-16.676-143.641z",
    vectorEffect: "non-scaling-stroke"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#d3e8ef",
    d: "M174.065 671.06l10.991 97.782c49.65-.379 89.823-16.676 119.764-62.156l26.53-76.558-29.562-1.516c-37.52 30.699-80.348 43.964-127.723 42.448z",
    vectorEffect: "non-scaling-stroke"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M174.065 671.06l6.822 57.987c68.6-8.338 122.417-36.384 150.084-98.919l-29.562-1.516c-37.52 30.699-80.348 43.964-127.344 42.448z",
    vectorEffect: "non-scaling-stroke"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#7eaaba",
    d: "M165.349 563.045c62.914 0 113.7 50.786 113.7 113.7s-50.786 113.7-113.7 113.7-113.7-50.786-113.7-113.7 51.164-113.7 113.7-113.7z",
    vectorEffect: "non-scaling-stroke"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#d3e8ef",
    d: "M165.349 585.027c-50.407 0-90.96 40.932-90.96 90.96 0 50.407 40.932 90.96 90.96 90.96 50.407 0 90.96-40.932 90.96-90.96.378-50.407-40.554-90.96-90.96-90.96z",
    vectorEffect: "non-scaling-stroke"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M165.339 585.037c-30.7 0-58.366 15.16-74.663 39.037 3.032 47.754 42.827 85.654 90.96 85.654 30.699 0 58.366-15.16 74.663-39.037-2.653-47.754-42.448-85.654-90.96-85.654z",
    vectorEffect: "non-scaling-stroke"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#7eaaba",
    d: "M153.6 579.342c46.996 0 84.896 37.9 84.896 84.896s-37.9 84.896-84.897 84.896-84.896-37.9-84.896-84.896 37.9-84.896 84.896-84.896z",
    vectorEffect: "non-scaling-stroke"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#7f3e13",
    d: "M147.525 556.602c46.996 0 85.275 38.279 85.275 85.275s-38.279 85.275-85.275 85.275-85.275-38.279-85.275-85.275c.38-46.996 38.658-85.275 85.275-85.275z",
    vectorEffect: "non-scaling-stroke"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#b85a1b",
    d: "M155.874 589.196c-37.521 0-67.841 30.32-67.841 67.841 0 37.521 30.32 67.841 67.84 67.841 37.522 0 67.842-30.32 67.842-67.841-.38-37.521-30.7-67.841-67.842-67.841z",
    vectorEffect: "non-scaling-stroke"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#7f3e13",
    d: "M105.125 487.624c1.516-47.754 72.39-50.407 74.284 0 20.845-34.868 86.033-15.539 65.567 39.037 1.137 4.548 1.895 8.717 2.653 12.886 35.247 1.895 46.996 57.229-1.516 74.284-4.169 15.16-10.233 28.425-18.95 39.037-41.69 35.626-54.955 6.443-77.316-17.813-21.603.758-81.106-14.781-64.43 40.932-37.9-23.877-62.535-72.768-43.964-145.157-25.772-57.608 42.07-79.211 63.672-43.206z",
    vectorEffect: "non-scaling-stroke"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#b85a1b",
    d: "M64.156 539.547c-9.097 34.868-9.476 74.284 15.538 102.709 34.869 39.795 105.742 37.9 132.65-12.128 14.403-27.288 13.645-61.019 7.58-90.581-51.922-11.749-104.603-9.854-155.768 0z",
    vectorEffect: "non-scaling-stroke"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#e1762f",
    d: "M64.156 539.547c-9.097 34.868-9.476 74.284 15.538 102.709 15.919 18.192 39.038 27.667 62.535 28.046V531.209c-26.15.379-52.302 3.411-78.074 8.338z",
    vectorEffect: "non-scaling-stroke"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#7f3e13",
    d: "M98.255 566.087c-4.926 19.329-5.305 41.69 9.097 57.229 19.328 22.361 58.744 21.224 73.904-7.201 8.339-15.16 7.96-33.731 4.17-50.407-28.804-6.064-58.745-4.927-87.17.379z",
    vectorEffect: "non-scaling-stroke"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#b85a1b",
    d: "M213.102 487.624c10.612 0 19.708 9.096 19.708 19.708 0 10.612-9.096 19.708-19.708 19.708-10.612 0-19.708-9.096-19.708-19.708 0-10.612 9.096-19.708 19.708-19.708zm-71.252 25.014c10.613 0 19.709-9.096 19.709-19.708 0-10.612-9.096-19.708-19.708-19.708v39.416z",
    vectorEffect: "non-scaling-stroke"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "#e1762f",
    d: "M141.84 512.638v-39.037c-10.612 0-19.708 9.096-19.708 19.708 0 10.991 8.717 19.708 19.708 19.329zm-67.462-22.74c10.612 0 19.708 9.096 19.708 19.708 0 10.612-9.096 19.708-19.708 19.708-10.612 0-19.708-9.096-19.708-19.708 0-10.612 9.096-19.708 19.708-19.708z",
    vectorEffect: "non-scaling-stroke"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "#b85a1b",
    d: "M235.084 559.265c10.612 0 19.708 9.096 19.708 19.708 0 10.612-9.096 19.708-19.708 19.708-10.612 0-19.708-9.096-19.708-19.708 0-10.991 8.717-19.708 19.708-19.708z",
    vectorEffect: "non-scaling-stroke"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "#7eaaba",
    d: "M911.22 791.961c-4.548-59.124-31.078-101.572-84.138-124.691l10.233-40.932 84.896-22.74c73.905 22.361 103.088 69.357 117.111 128.86l-128.101 59.503z",
    vectorEffect: "non-scaling-stroke"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M929.034 759.377l84.517-39.416c-14.781-49.27-39.416-81.485-91.34-93.992l-66.324 17.813-3.032 10.991c40.932 23.877 65.567 59.503 76.179 104.604z",
    vectorEffect: "non-scaling-stroke"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "#7eaaba",
    d: "M829.736 801.815c-18.95-57.987 12.128-120.522 70.115-139.472 57.987-18.95 120.522 12.128 139.472 70.115 18.95 57.987-12.129 120.522-70.116 139.472-58.366 19.329-120.522-12.128-139.472-70.115z",
    vectorEffect: "non-scaling-stroke"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "#d3e8ef",
    d: "M847.918 795.751c15.539 48.133 67.462 73.905 115.216 57.987 48.133-15.539 73.905-67.462 57.987-115.216-15.54-48.133-67.462-73.905-115.216-57.987-48.133 15.539-74.284 67.083-57.987 115.216z",
    vectorEffect: "non-scaling-stroke"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M1024.91 754.819c-.758-5.685-1.895-10.612-3.79-16.297-15.539-48.133-67.462-73.905-115.216-57.987-14.78 4.927-27.667 12.886-37.142 23.498.758 5.685 1.895 10.612 3.79 16.297 15.918 48.133 67.462 73.905 115.216 57.987 14.781-4.927 27.288-13.265 37.142-23.498z",
    vectorEffect: "non-scaling-stroke"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fill: "#7f3e13",
    d: "M808.89 830.24c-18.192-54.576 11.37-113.7 66.325-131.513 54.576-18.192 113.7 11.37 131.513 66.325 18.193 54.576-11.37 113.7-66.324 131.513-54.576 18.192-113.7-11.749-131.513-66.325z",
    vectorEffect: "non-scaling-stroke"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fill: "#b85a1b",
    d: "M830.115 823.418c-14.023-43.206 9.475-89.065 51.923-103.467 43.206-14.023 89.065 9.475 103.467 51.923 14.023 43.206-9.475 89.065-51.923 103.467-43.206 14.402-89.444-9.096-103.467-51.923z",
    vectorEffect: "non-scaling-stroke"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fill: "#e1762f",
    d: "M826.703 784.76c4.927-29.562 25.393-54.955 55.334-65.188 43.206-14.023 89.065 9.475 103.467 51.923 2.274 6.822 3.79 13.644 4.17 20.466-53.06 33.731-122.039 26.151-162.97-7.201z",
    vectorEffect: "non-scaling-stroke"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fill: "#7f3e13",
    d: "M448.462 160.547c41.69 0 75.042 35.626 75.042 79.59 0 43.964-33.352 79.59-75.042 79.59-41.69 0-75.042-35.626-75.042-79.59 0-43.964 33.351-79.59 75.041-79.59z",
    vectorEffect: "non-scaling-stroke"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fill: "#b85a1b",
    d: "M448.462 182.529c-30.7 0-53.06 27.667-53.06 57.608 0 29.562 22.36 57.608 53.06 57.608s53.06-27.667 53.06-57.608c0-29.941-22.361-57.608-53.06-57.608z",
    vectorEffect: "non-scaling-stroke"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fill: "#63300f",
    d: "M448.462 204.511c-18.95 0-31.078 17.813-31.078 35.626 0 17.434 12.507 35.626 31.078 35.626 18.95 0 31.078-17.813 31.078-35.626 0-17.434-12.508-35.626-31.079-35.626z",
    vectorEffect: "non-scaling-stroke"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fill: "#7f3e13",
    d: "M767.958 160.547c41.69 0 75.042 35.626 75.042 79.59 0 43.964-33.352 79.59-75.042 79.59-41.69 0-75.042-35.626-75.042-79.59 0-43.964 33.352-79.59 75.042-79.59z",
    vectorEffect: "non-scaling-stroke"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fill: "#b85a1b",
    d: "M767.958 182.529c-30.699 0-53.06 27.667-53.06 57.608 0 29.562 22.361 57.608 53.06 57.608s53.06-27.667 53.06-57.608c0-29.941-22.36-57.608-53.06-57.608z",
    vectorEffect: "non-scaling-stroke"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fill: "#4f2800",
    d: "M767.958 204.511c-18.95 0-31.078 17.813-31.078 35.626 0 17.434 12.507 35.626 31.078 35.626 18.95 0 31.078-17.813 31.078-35.626 0-17.434-12.507-35.626-31.078-35.626z",
    vectorEffect: "non-scaling-stroke"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fill: "#7f3e13",
    d: "M577.7 197.689c12.886 0 23.877 10.612 23.877 23.877 0 12.886-10.612 23.877-23.877 23.877-12.886 0-23.877-10.612-23.877-23.877.38-12.886 10.992-23.877 23.878-23.877zm60.64 0c12.886 0 23.877 10.612 23.877 23.877 0 12.886-10.612 23.877-23.877 23.877-12.886 0-23.877-10.612-23.877-23.877.38-12.886 10.992-23.877 23.878-23.877z",
    vectorEffect: "non-scaling-stroke"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fill: "#7f3e13",
    d: "M885.827 296.987v147.81l1.516.379c21.603 8.717 35.247 28.425 35.247 51.544v106.499L608.4 707.065 294.209 605.872V497.099c0-23.498 13.644-43.206 35.247-51.544l1.516-.379V296.608c0-102.33 554.856-102.33 554.856.379z",
    vectorEffect: "non-scaling-stroke"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fill: "#b85a1b",
    d: "M355.986 302.682v159.559l-12.886 5.306c-14.403 5.685-23.499 18.95-23.499 34.489V614.22L608.4 707.075l288.798-95.129v-109.91c0-15.539-9.096-28.804-23.498-34.489l-12.886-5.306V302.682c0-75.8-504.449-75.8-504.827 0z",
    vectorEffect: "non-scaling-stroke"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fill: "#e1762f",
    d: "M355.986 302.682v159.559l-12.886 5.306c-14.403 5.685-23.499 18.95-23.499 34.489V614.22L608.4 707.075v-61.019c-100.056.379-200.112-65.188-173.582-194.806H608.4V246.211c-126.207 0-252.413 18.95-252.413 56.471z",
    vectorEffect: "non-scaling-stroke"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fill: "#e5895b",
    d: "M420.822 417.519h375.59c53.438 281.976-432.819 279.702-375.59 0z",
    vectorEffect: "non-scaling-stroke"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fill: "#e5895b",
    d: "M439.356 439.491c-5.306 43.585 4.169 85.654 36.384 118.248 34.11 34.11 86.033 48.891 133.407 48.891 45.86-.379 94.371-14.781 128.102-47.375 33.731-32.594 44.343-75.042 39.795-119.764H439.355z",
    vectorEffect: "non-scaling-stroke"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    fill: "#fad395",
    d: "M671.351 571.004c25.393 32.594 98.92 19.329 76.937-49.649l-76.937 49.649z",
    vectorEffect: "non-scaling-stroke"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    fill: "#4f2800",
    d: "M648.232 563.803c28.425 36.384 120.522 14.781 99.298-64.051l-99.298 64.051z",
    vectorEffect: "non-scaling-stroke"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M672.83 544.853c5.685-1.516 10.99 2.274 12.886 8.338 1.516 6.064-1.516 12.128-7.201 13.644s-10.991-2.274-12.886-8.338c-1.516-5.685 1.516-12.128 7.2-13.644zm60.26-41.311c5.685-1.516 11.37 2.274 12.886 8.338 1.516 6.064-1.516 12.128-7.2 13.644s-11.37-2.274-12.886-8.338c-1.516-6.064 1.516-12.507 7.2-13.644z",
    vectorEffect: "non-scaling-stroke"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    fill: "#ad6151",
    d: "M710 577.836c20.086-6.822 37.52-22.74 40.552-48.512-16.676-2.274-44.722 21.603-40.553 48.512z",
    vectorEffect: "non-scaling-stroke"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    fill: "#fad395",
    d: "M459.452 417.519h297.894c42.07 201.249-342.995 199.354-297.894 0z",
    vectorEffect: "non-scaling-stroke"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    fill: "#4f2800",
    d: "M608.427 531.977c1.895-12.128 6.443-23.498 14.023-33.352 35.626-5.685 66.704-32.594 56.85-81.485a210.642 210.642 0 00-70.494-12.128l-14.402 46.238 14.023 80.727z",
    vectorEffect: "non-scaling-stroke"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    fill: "#63300f",
    d: "M608.4 531.977c-1.895-12.128-6.443-23.498-14.023-33.352-35.626-5.685-66.704-32.594-56.85-81.485a210.642 210.642 0 0170.493-12.128l.38 126.965z",
    vectorEffect: "non-scaling-stroke"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    fill: "#ad6151",
    d: "M555.708 424.341c35.247-9.475 70.115-9.475 105.741 0 14.402 36.763-122.038 36.384-105.74 0z",
    vectorEffect: "non-scaling-stroke"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M551.55 322.001c21.982 0 39.795 17.813 39.795 39.795 0 21.982-17.814 39.795-39.796 39.795s-39.795-17.813-39.795-39.795c0-21.982 17.813-39.795 39.795-39.795z",
    vectorEffect: "non-scaling-stroke"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    fill: "#1b1d23",
    d: "M554.582 335.645c16.297 0 29.562 13.265 29.562 29.562s-13.265 29.562-29.562 29.562-29.562-13.265-29.562-29.562c-.38-16.297 12.886-29.562 29.562-29.562z",
    vectorEffect: "non-scaling-stroke"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M666.008 322.001c-21.982 0-39.795 17.813-39.795 39.795 0 21.982 17.813 39.795 39.795 39.795 21.982 0 39.795-17.813 39.795-39.795 0-21.982-17.813-39.795-39.795-39.795z",
    vectorEffect: "non-scaling-stroke"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    fill: "#1b1d23",
    d: "M662.976 335.645c-16.297 0-29.562 13.265-29.562 29.562s13.265 29.562 29.562 29.562 29.562-13.265 29.562-29.562c.379-16.297-13.265-29.562-29.562-29.562z",
    vectorEffect: "non-scaling-stroke"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    fill: "#63300f",
    d: "M580.343 308.736c-31.457-6.064-58.745-.379-82.622 14.402-8.338-48.512 73.905-62.914 82.622-14.402z",
    vectorEffect: "non-scaling-stroke"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    fill: "#4f2800",
    d: "M628.865 284.48c31.457-6.064 58.745-.379 82.622 14.402 8.338-48.891-73.905-63.293-82.622-14.402z",
    vectorEffect: "non-scaling-stroke"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    fill: "#7eaaba",
    d: "M922.212 603.598v305.853c0 20.466-16.676 37.142-37.142 37.142h-554.1c-20.466 0-37.142-16.676-37.142-37.142V605.872l314.191 75.042 314.191-77.316z",
    vectorEffect: "non-scaling-stroke"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    fill: "#d3e8ef",
    d: "M897.197 635.813L608.4 707.065l-289.177-68.978v265.3c0 10.233 8.338 18.571 18.571 18.571h540.833c10.233 0 18.571-8.338 18.571-18.571V635.813z",
    vectorEffect: "non-scaling-stroke"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M608.4 707.075l-288.798-68.978v265.3c0 10.233 8.338 18.571 18.57 18.571H608.4V707.075z",
    vectorEffect: "non-scaling-stroke"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    fill: "#036aab",
    d: "M608.4 782.107h242.939v32.594h-242.94v-32.594zm0 67.462h242.939v32.594h-242.94v-32.594z",
    vectorEffect: "non-scaling-stroke"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    fill: "#0399ed",
    d: "M365.46 782.107H608.4v32.594H365.46v-32.594zM608.4 882.163v-32.594H365.46v32.594H608.4z",
    vectorEffect: "non-scaling-stroke"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M464 760.883h30.7v148.568H464z",
    vectorEffect: "non-scaling-stroke"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    fill: "#7eaaba",
    d: "M378.726 626.348c76.558 18.192 153.116 36.763 229.294 54.955l-81.864 77.316c-53.06-31.078-105.74-65.567-147.43-132.271z",
    vectorEffect: "non-scaling-stroke"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M443.534 667.649c23.498 23.119 49.27 41.69 79.211 59.882l34.49-32.594-113.7-27.288z",
    vectorEffect: "non-scaling-stroke"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    fill: "#7eaaba",
    d: "M837.684 626.348c-76.558 18.192-153.116 36.763-229.294 54.955l81.864 77.316c53.06-31.078 105.362-65.567 147.43-132.271z",
    vectorEffect: "non-scaling-stroke"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M772.496 667.649c-23.498 23.119-49.27 41.69-79.21 59.882l-34.49-32.594 113.7-27.288z",
    vectorEffect: "non-scaling-stroke"
  })));
}
export default __webpack_public_path__ + "static/wpforms.1ba479b6.svg";
export { SvgWpforms as ReactComponent };